<template>    
  <el-scrollbar style="background-color:rgb(60,65,76);">      
      <div class="bg" :style="{'height':FirstHeight+'px','width':FirstWidth+'px'}">
        <div class="top_title">
          <img :src="logo" alt="Logo">
          <div>枝江市农合联金融平台</div>
       </div>
    <div class="datas">
      <div class="data_left">
        <div class="left_top">
          <div class="left_top_title">客户性质</div>
          <div class="left_top_main" style="margin-top:6%">
            <div class="left_main_circle">
              <p class="counter-value circle_num1">新增</p>
              <span class="span_font">{{data1[0]}}笔<br/>{{data1[1]}}万</span>
            </div>
            <div class="left_main_circle">
              <p class="counter-value circle_num1">续贷</p>
              <span class="span_font">{{data1[2]}}笔<br/>{{data1[3]}}万</span>
            </div>
            <div class="left_main_circle">
              <p class="counter-value circle_num1">展期</p>
              <span class="span_font">{{data1[4]}}笔<br/>{{data1[5]}}万</span>
            </div>
          </div>
        </div>
        <div class="left_middle">
          <div class="left_top_title">客户类型</div>
          <div id="chart2" class="mychart"></div>
        </div>
        <div class="left_bottom">
          <div class="left_top_title">主营业务</div>
          <div id="chart3" class="mychart"></div>
        </div>
      </div>
      <div class="data_middle">
        <div class="middle_top">
          <div class="middle_top_list">
            <div class="list_title">累计担保数量</div>
            <div class="list_num list_num1"><span class="counter-value">{{ data0[0] }}</span>笔</div>
            <div class="today_list_font">近30天担保<span>{{ data0[3] }}</span>笔</div>
          </div>
          <div class="middle_top_list">
              <div class="list_title">累计担保金额</div>
              <div class="list_num list_num2"><span class="counter-value">{{ data0[1] }}</span>万</div>
              <div class="today_list_font">近30天担保<span>{{ data0[4] }}</span>万</div>
          </div>
          <div class="middle_top_list">
              <div class="list_title">累计担保费用</div>
              <div class="list_num list_num3"><span class="counter-value">{{ data0[2] }}</span>万</div>
              <div class="today_list_font">近30天担保费用<span>{{ data0[5] }}</span>万</div>
          </div>
        </div>
        <div id="map" class="middle_middle" ></div>
        <div class="middle_bottom" id="drag-container" style="z-index: 1" > 
          <div class="rotate-page-content-box-container">
          <div class="rotate-item item0" :class="{ 'itemclass1': index==0, 'itemclass2': index!=0 }" id="item0"  @click="rotateElement(0)">全部</div>
          <div class="rotate-item item1"  id="item1" :class="{ 'itemclass1': index==1, 'itemclass2': index!=1 }" @click="rotateElement(1)">在保</div>
          <div class="rotate-item item2"  id="item2" :class="{ 'itemclass1': index==2, 'itemclass2': index!=2 }" @click="rotateElement(2)">结清</div>
          <div class="rotate-item item3"  id="item3" :class="{ 'itemclass1': index==3, 'itemclass2': index!=3 }" @click="rotateElement(3)">逾期</div>
          <div class="rotate-item item4"  id="item4" :class="{ 'itemclass1': index==4, 'itemclass2': index!=4 }" @click="rotateElement(4)">代偿</div>
        </div>
        </div>
      </div>
      <div class="data_right">
        <div class="right_top">
          <div class="left_top_title">贷款规模</div>
          <div id="chart4" class="mychart"></div>
          </div>
          
        <div class="right_middle">
          <div class="left_top_title">贷款类型Top5</div>
          <div id="chart5" class="mychart"></div>
        </div>
        <div class="right_bottom">
          <div class="left_top_title">贷款银行</div>
          <div class="titleContent">
      <div class="tit" style="width: 8%;">序号</div>
      <div class="tit" style="width: 50%;">银行名称</div>
      <div class="tit" style="width: 14%;">贷款笔数</div>
      <div class="tit" style="width: 14%;">贷款金额</div>
      <div class="tit" style="width: 14%;">金额占比</div>
    </div>
    <!-- 配置详情请见 README.md -->
    <vue3-seamless-scroll         
        class="scroll-list"
        :list="data6List"
        :hover="true"
        :step="0.8"
        :limitScrollNum="6">
      <div class="countContent" v-for="(item, i) in data6List" :key="i">
        <div class="descr" style="width: 8%;">{{ i+1}}</div>
        <div class="descr" style="width: 50%;">{{ item.BankName }}</div>
        <div class="descr" style="width: 14%;">{{ item.num }}</div>
        <div class="descr" style="width: 14%;">{{ item.money }}</div>
        <div class="descr" style="width: 14%;">{{ item.per }}%</div>
      </div>
    </vue3-seamless-scroll>
        </div>
      </div>
    </div>

      </div>
    </el-scrollbar>
</template>

<script>
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import apis  from "../api/flow";
import szmap  from '../assets/json/zj.svg'
import * as echarts from 'echarts' 
export default {
  components: {
        Vue3SeamlessScroll
      },
data() {
    return {
      query:{},
      index:0,
      FirstHeight:980,
      FirstWidth:1400,
      logo: require('@/assets/img/data/top_title.png'),
      midChart:null,
      chart2:null,
      chart3:null,
      chart4:null,
      chart5:null,
      datamap:[
                { value: 0, name: '百里洲镇' ,num:0},
                { value: 0, name: '七星台镇',num:0 },
                { value: 0, name: '问安镇',num:0 },
                { value: 0, name: '仙女镇' ,num:0},
                { value: 0, name: '顾家店镇' ,num:0},
                { value: 0, name: '白洋镇' ,num:0},
                { value: 0, name: '安福寺镇',num:0 },
                { value: 0, name: '马家店街道',num:0 },
                { value: 0, name: '董市镇' ,num:0}],
      data0:[0,0,0,0,0,0],
      data1:[0,0,0,0,0,0],
      data2:[
              {value:0, name:'家庭农场'},
              {value:0, name:'合作社'},
              {value:0, name:'公司'},
              {value:0, name:'种养大户'},
              {value:0, name:'个体户'}
          ],
      data3x:['电商','种植','养殖','农产品加工','农资农机销售','其他'],
      data3y:[0,0,0,0,0,0],
      data4:[
              {value:0, name:'大规模（≥300万）'},
              {value:0, name:'中规模（100-300万）'},
              {value:0, name:'小规模（<100万）'},
          ],
          data5:[
          ['product', '金额', '数量'],
          ['助企新贷', 0, 0],
          ['助企易贷', 0, 0],
          ['助企纾困贷', 0, 0],
          ['农担联合贷', 0, 0],
          ['供应链贷', 0, 0],
      ],
      data6List:[{ money: 0, BankName: '湖北枝江农村商业银行股份有限公司' ,num:0,per:0},
      { money: 0, BankName: '中国农业银行股份有限公司枝江支行' ,num:0,per:0},
      { money: 0, BankName: '枝江汉银村镇银行股份有限公司' ,num:0,per:0},
      { money: 0, BankName: '中国银行股份有限公司枝江支行' ,num:0,per:0},
      { money: 0, BankName: '中国邮政储蓄银行股份有限公司枝江支行' ,num:0,per:0}]
                
    };
  },
  mounted() {
    let that = this;
    that.calcTableHeight();
    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize() {
        that.calcTableHeight();
     }
     
   },
   created() {
		 var startTime=this.$route.query.startTime;
		 var endTime=this.$route.query.endTime;
     var db=this.$route.query.db;
		 this.query={
			startTime:startTime,
			endTime:endTime,
      db:db
		 }
     this.getData();
    },
    methods: {
      getData() {
			  let that = this;
			  let obj=this.query;
        obj.type=this.index
			  apis.getDataReport(obj).then(res => {
				    var data0=res.data0;
            data0[2]=(data0[2]/100.0).toFixed(2)
            data0[5]=(data0[5]/100.0).toFixed(2)
            that.data0=data0;
            that.data1=res.data1;
            var data6=res.data6;
            data6.sort(function (a, b) {
              return b.money - a.money;})
            for(var i=0;i<data6.length;i++){
              data6[i].per=(data6[i].money*100/data0[1]).toFixed(2);
            }
            that.data6List=data6;
            var datamap=res.datamap;
            for(var i=0;i<9;i++){
              that.datamap[i].num=datamap[i*2];
              that.datamap[i].value=datamap[i*2+1];
            }
            this.initchartMiddle(0);
            var data2=res.data2;
            for(var i=0;i<4;i++){
              that.data2[i].value=data2[i*2+1];
            }
            this.initchart2(0);
            var data3=res.data3;
            var data3x=['电商','种植','养殖','农产品加工','农资农机销售','农产品购销','农业服务','农业旅游农家乐','农业相关工程','其他'];
            var data3y=[]
            var data3list=[];
            for(var i=0;i<10;i++){
              if(data3[i*2+1]!=0){
                 data3list.push({
                  name:data3x[i],value:data3[i*2+1]
                 })
              };
            }
            data3list.sort(function (a, b) {
                    return a.value - b.value;})
                      data3x=[];
            for(var i=0;i<data3list.length;i++){
                 data3x.push(data3list[i].name)
                 data3y.push(data3list[i].value)
            }
            if(data3x.length==0){
              data3x=['电商','种植','养殖','农产品加工','农资农机销售','其他']
              data3y=[0,0,0,0,0,0]}
              this.data3x=data3x;
              this.data3y=data3y;
            this.initchart3();
            
            var data4=res.data4;
            for(var i=0;i<3;i++){
              that.data4[i].value=data4[i*2+1];
            }
            this.initchart4();

            var data4=res.data4;
            for(var i=0;i<3;i++){
              that.data4[i].value=data4[i*2+1];
            }
            this.initchart4();
            
            var data5=res.data5;
            data5.sort(function (a, b) {
              return b.money - a.money;})
            var nowdata5=[['product', '金额', '数量']]
            for(var i=0;i<data5.length&&i<5;i++){
              var list5=[data5[i].name,data5[i].money,data5[i].num];   
              nowdata5.push(list5)
            }
            this.data5=nowdata5;
            this.initchart5();
			  });
		  },
      initChart(){
        this.initchartMiddle(0);
        this.initchart2(0)
        this.initchart3(0)
        this.initchart4(0)
        this.initchart5(0)
      },
      initchart2(flag){
            if(this.chart2){
              if(flag==1){this.chart2.resize();return}
              else this.chart2.dispose();
            }
            var MidWidth=this.FirstWidth*0.95*0.26*0.9
            var MidHeight=this.FirstHeight*0.8*0.30*0.88;
            this.chart2= echarts.init(document.getElementById('chart2'),null,{width:MidWidth,height:MidHeight});
           
// 指定图表的配置项和数据
var data2=this.data2;
var option1 = {
  grid: {
        left: '2%',
        right: '2%',
        bottom: '2%',
        top:'2%',
        containLabel: true
    },
  tooltip : {
      trigger: 'item',
      formatter: "{a} <br/>{b} : {c} 万元({d}%)"
  },
  series : [
      {
          name: '贷款金额',
          type: 'pie',
          radius: ['50%', '80%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          data:data2,
          label: {
                formatter: "{b}({d}%)",
                show: true, // 显示标签
                color: '#fff' // 设置标签颜色为红色
            }
      }
  ],
  color : ['#F3DB5D','#009AFF','#F77474','#28DCCF','#FF5937']
};
// 使用刚指定的配置项和数据显示图表。
this.chart2.setOption(option1);
      },
      initchart5(flag){
         if(this.chart5){
              if(flag==1){this.chart5.resize();return}
              else this.chart5.dispose();
            }
            var MidWidth=this.FirstWidth*0.95*0.31*0.9
            var MidHeight=this.FirstHeight*0.8*0.25;
           var chart5 = echarts.init(document.getElementById('chart5'),null,{width:MidWidth,height:MidHeight});
           var projectArr=['岳阳市','益阳市','长沙市','株洲市','海慧寺']
           var data5=this.data5;
var option5 = {
  grid: {
        left: '1%',
        right: '1%',
        bottom:  '0%',
        top:'20%',
        containLabel: true
    },
  legend: {
    x : 'center',
    y : 'top',
    textStyle: {
      color:'#4ADEFE',
    }
  },
  tooltip: {
                     trigger: 'item',
                     textStyle:{
                         fontSize:16,
                     },
                     formatter: (params) => { //格式化数据的函数
                         var name=params.seriesName;
                         if(name=="金额")return name+"<br>"+params.data[0]+':'+params.data[1]+"万元";
                         else return name+"<br>"+params.data[0]+':'+params.data[2]+"笔";
                       }
                     },
  dataset: {
      source: data5
  },
  xAxis: {
    type: 'category',
    axisLine: {
      show: true,
      lineStyle: {
        color: "#4ADEFE",
      },
    },
    axisTick: {
      alignWithLabel: true
    },
    axisLabel: {textStyle: {
                color: '#ffffff' // 设置 x 轴文字颜色为红色
            },
            interval: 0, 
                            // 文字换行
                            formatter: function (value) {
                              let res = ""; // 拼接加\n返回的类目项
                              let maxLength = 4; // 每项显示文字个数  数字设置几，就一行显示几个文字
                              if(projectArr.length<3)maxLength=8;  
                              let valLength = value.length; // X轴上的文字个数
                              let rowN = Math.ceil(valLength / maxLength); // 需要换行的行数
                              // 换行的行数大于1,
                              if (rowN > 1) {
                                for (let i = 0; i < rowN; i++) {
                                  let temp = ""; //每次截取的字符串
                                  let start = i * maxLength; //开始截取的位置
                                  let end = start + maxLength; //结束截取的位置
                                  temp = value.substring(start, end) + "\n";
                                  res += temp; //拼接字符串
                                }
                                return res;
                              } else {
                                return value;
                              }
                            },
                          },
  },
  yAxis: [
                    {
                        type: 'value',
                        name: '数量',
                        min: 0,
                        position: 'right',
                        axisLine: {
                            show: false, 
                            lineStyle: {
                              color: "#4ADEFE",
                            }
                        },
                        axisTick: {  show: false },
                        splitLine:{ 
                           show: true ,
                           lineStyle: {
                    type: 'dashed' // 设置虚线类型
                    }
                          },
                        splitNumber: 3,
                        axisLabel: {
                            formatter: '{value} '
                        }
                    },
                    
                    {
                        type: 'value',
                        name: '金额/万元',
                        min: 0,
                        position: 'left',
                        axisLine: {
                           show: false, 
                            lineStyle: {
                               color: '#4ADEFE'
                            }
                        },
                        axisTick: {  show: false },
                        splitLine:{  show: false },
                        axisLabel: {
                            formatter: '{value}'
                        }
                    }
                ],
  series: [
    {
      type: 'bar',
      barMaxWidth: '10',
      yAxisIndex: 1,
      itemStyle: { 
        normal:{    
          color: '#4ADEFE'     
        },
      },
    },
    {
      type: 'bar',
      yAxisIndex: 0,
      barMaxWidth: '10',
      itemStyle: { 
        normal:{    
          color: '#F3DB5C',
        },
      },
    }
  ]
};


chart5.setOption(option5);
this.chart5=chart5;
      },
      initchart4(flag){
        if(this.chart4){
              if(flag==1){this.chart4.resize();return}
              else this.chart4.dispose();
            }
            var MidWidth=this.FirstWidth*0.95*0.31*0.9
            var MidHeight=this.FirstHeight*0.8*0.26*0.88;
           this.chart4 = echarts.init(document.getElementById('chart4'),null,{width:MidWidth,height:MidHeight});
// 指定图表的配置项和数据
var data4=this.data4;
var option1 = {
  grid: {
        left: '2%',
        right: '2%',
        bottom: '2%',
        top:'2%',
        containLabel: true
    },
    legend: {
      orient: 'vertical',
        right: 20,           // 距离左侧的距离
        top: 20,            // 距离顶部的距离
        width: 40,          // 图例宽度
        height: 100,         // 图例高度
        itemWidth: 40,      // 图例标记图形宽度
        itemHeight: 20,     // 图例标记图形高度
        itemGap: 20,         // 图例每项之间的间
    textStyle: {
      color:'#fff',
    }
  },
  tooltip : {
      trigger: 'item',
      formatter: "贷款金额<br/>  {b}：{c}万元 ({d}%)"
  },
  series : [
      {
          name: '累计金额',
          type: 'pie',
          center: ['35%', '50%'],
          radius: ['0%', '90%'],
          avoidLabelOverlap: false,
          data:data4,
          label: {
                show: true, // 显示标签
                color: '#000000', // 设置标签颜色为红色
                formatter: "{c}万\n ({d}%)",
                position:"inner"
            }
      }
  ],
  color : ['#F3DB5D','#F77474','#28DCCF','#FF5937']
};
// 使用刚指定的配置项和数据显示图表。
this.chart4.setOption(option1);
      },
      initchart3(flag){
        if(this.chart3){
              if(flag==1){this.chart3.resize();return}
              else this.chart3.dispose();
            }
        var MidWidth=this.FirstWidth*0.95*0.26*0.9
        var MidHeight=this.FirstHeight*0.8*0.34*0.88;
            this.chart3 = echarts.init(document.getElementById('chart3'),null,{width:MidWidth,height:MidHeight});
var data3x=this.data3x;var data3y=this.data3y;
var option3 = {
  tooltip : {
      trigger: 'item',
      formatter: "{a} <br/>{b} : {c}万元"
  },
    grid: {
        left: '2%',
        right: '2%',
        bottom: '2%',
        top:'2%',
        containLabel: true
    },
    xAxis: {
        type: 'value',
        axisLine: {
      show: false,
      lineStyle: {
        color: "#ffffff",
      },
      },
      splitNumber: 4,
        splitLine: {
            show: true
        },
      axisLabel: {
                            formatter: '{value} 万',
                          rotate:20 
                        }
    },
    yAxis: {
        type: 'category',
        axisLine: {
         show: false,
         lineStyle: {
          color: "#4ADEFE",
         },
       },
        data: data3x
        
      },
    series: [
        {
            name: '贷款金额',
            type: 'bar',
            barMaxWidth: '20',
            orientation: 'horizontal', // 设置为横向
            data: data3y,
            itemStyle: {
          normal: {
              barBorderRadius: [0, 10, 10, 0],//设置圆角
              color: function(params) {
                //给每个柱子设置不同的颜色
                  let colorList = ['#6BBAFF','#EA418B','#FFA500','#14D2B9','#F44E60','#5A7BEF'];
                 return colorList[params.dataIndex%6]
              }
          }
      },
        }
    ]
};
this.chart3.setOption(option3);

      },
      initchartMiddle() {
            if(this.midChart)this.midChart.dispose();
            var data=this.datamap;
            var max=1;
            for(var i=0;i<data.length;i++){
                if(Number(data[i].value)>max)max=Number(data[i].value);
            };
            var chartDom = document.getElementById("map");
            var MidWidth=this.FirstWidth*0.95*0.38
            var MidHeight=this.FirstHeight*0.8*0.75;
            var myChart = echarts.init(chartDom,null,{width:MidWidth,height:MidHeight});
            this.midChart=myChart;
            var option;
            $.get(szmap, function (svg) {
              echarts.registerMap("szmap", { svg: svg });
              option = {
                  tooltip: {
                     trigger: 'item',
                     textStyle:{
                        //  color:'#fff',
                         fontSize:16,
                     },
                     borderWidth:0,
                    //  backgroundColor:'#00bfff;',//提示框背景色
                     formatter: (params) => { //格式化数据的函数
                         return params.data.name+'<br/>'+params.data.num+"笔"+params.data.value+"万元";
                       }
                     },
                     visualMap: {
                        min: 0,
                        max: max,
                        text: ['高', '低'],
                        realtime: false,
                        calculable: true,
                        inRange: {
                          color: ['#0666D5','#062A6C']
                        }
                      },
                series: [
                  {
                  type: "map",
                  map: "szmap",
                  // borderColor: '#6099EC',
                  // borderWidth: 0.5,

                  zoom:1.2,
                   label: {
                      show: true,
                      position: 'inside',
                      color:'#fff',
                      fontSize:16,
                      letterspace:1,
                      formatter: (params) => { //格式化数据的函数
                        return params.data.name;
                      }
                    },
                   emphasis: {
                    
                   },
                //    selectedMode: true,
                //    select:{
                //       itemStyle: {
                //    //    areaColor: '#258ee9',29b4ff
                //    areaColor: '#29b4ff',
                //               }
                //    },
                   data: data
                },
             ],
             };
             myChart.setOption(option);
             });
          },
        calcTableHeight() {
          var that=this;
          that.$nextTick(() => {
          var browserWidth = window.innerWidth;
          if(browserWidth<1400)browserWidth=1400;
          var height=document.body.clientHeight;
          var oldheight=980;
          if(height>980)oldheight=height;
          that.FirstWidth=browserWidth;
          that.FirstHeight = oldheight;
          that.initChart();
        });
      },
      rotateElement(i){
        this.index=i;
        this.getData();
        var item0=document.getElementById('item0');
        var item1=document.getElementById('item1');
        var item2=document.getElementById('item2');
        var item3=document.getElementById('item3');
        var item4=document.getElementById('item4');
            var list=[null,null,null,null,null];
            if(i==0)list=[item0,item1,item2,item3,item4]
            if(i==1)list=[item1,item2,item3,item4,item0]
            if(i==2)list=[item2,item3,item4,item0,item1]
            if(i==3)list=[item3,item4,item0,item1,item2]
            if(i==4)list=[item4,item0,item1,item2,item3]
            list[0].style.transform = `rotateX(-16deg) rotateY(0)translateZ(20vw)`;
            list[1].style.transform = `rotateX(-16deg) rotateY(25deg)translateZ(20vw)`;
            list[2].style.transform = `rotateX(-16deg) rotateY(50deg)translateZ(20vw)`;
            list[3].style.transform = `rotateX(-16deg) rotateY(-50deg)translateZ(20vw)`;
            list[4].style.transform = `rotateX(-16deg) rotateY(-25deg)translateZ(20vw)`;

      }
    }
};
</script>

<style>     
.bg{
     color: white;
     background-image: url(../assets/img/data/bg.jpg);
     background-size:cover;
     background-repeat:no-repeat;
}
.top_title {
			width: 100%;
			padding-top: 20px;
      height: 60px;
		}
			.top_title img {
				width: 100%;
        height: 60px;
			}  
      .top_title div {
				width: 100%;
        text-align: center;
        position: relative;
        top:-60px;
        font-size:36px;
        color: #daf9ff;
			}   
			.datas {
				width: 95%;
				height: 80%;
				margin: auto;
        margin-top:1.6%;
			}
				.data_left,.data_middle,.data_right {
					float: left;
					height: 100%;
				}
				.data_left {
					width: 26%;
				}
					.left_top {
						width: 100%;
						height: 20%;
            min-height: 200px;
						background: url(../assets/img/data/dataBg.png) no-repeat;
						background-size:cover;
					}
						.left_top_title {
							font-size: 16px;
							color: #FFFFFF;
							padding-left: 10%;
							padding-top: 5%;
              padding-bottom: 1%;
              height: 4%;
						}
						.left_top_main {
							width: 90%;
							height: 76%;
							margin: auto;
							margin-top: 4%;
						}
            .mychart{
              width: 90%;
              height: 88%;
              margin-top: 2%;
              margin-left: 5%;
            }
							.left_main_circle {
								float: left;
								width: 30%;
								height: 44%;
								background: url(../assets/img/data/cicleBg.png) no-repeat;
								background-size: 100%; 
								color: #4ADEFE;
								text-align: center;
							}
								.left_main_circle p {
									font-size: 20px;
									margin-top: 20%;
								}
								.left_main_circle span {
									font-size: 16px;
								}
							.left_main_circle:nth-of-type(2) {
								margin-left: 5%;
							}
							.left_main_circle:nth-of-type(3) {
								margin-left: 5%;
							}
					.left_bottom {
						width: 100%;
						height: 38%;
            min-height: 290px;
						background: url(../assets/img/data/dataBg.png) no-repeat;
						background-size:cover;
						margin-top: 6%;
					}
          .left_middle {
						width: 100%;
            height: 30%;
            min-height: 290px;
						background: url(../assets/img/data/dataBg.png) no-repeat;
						background-size:cover;
						margin-top: 6%;
					}
				.data_middle {
					width: 38%;
					margin: 0 2.5%;
					/* background: white; */
				}
					.middle_top {
						width: 100%;
						height: 12%;
					}
						.middle_top_list {
							float: left;
							width: 33.2%;
							height: 65%;
							margin-top: 5%;
							text-align: center;
							color: #4ADEFE;
						}
							.middle_top_list span {
								color: #F3DB5C;
							}
							.list_title {
								font-size: 18px;
								margin-top: -15%;
							}
							.list_num {
								margin-top: 3%;
								font-size: 16px;
							}
								.list_num span {
									font-size: 30px;
								}
							.today_list_font {
								font-size: 14px;
								margin-top: 4%;
							}
						.middle_top_list:nth-of-type(2) {
							border-left: 1px solid #4E72B0;
							border-right: 1px solid #4E72B0;
						}
					.middle_bottom {
            width: 100%;
						height: 120px;
						background: transparent;
            position: relative;
            top:-10px;

					}
          .middle_middle {
            width: 100%;
						height: 75%;
						background: transparent;
					}
				.data_right {
					width: 31%;
				}
					.right_top {
						width: 100%;
            height: 26%;
            min-height: 240px;
						background: url(../assets/img/data/msgBg.png) no-repeat;
						background-size:cover;
					}
						.right_top_main {
							width: 95%;
						}
					.right_bottom {
						width: 100%;
            height: 36%;
            min-height: 260px;
						background: url(../assets/img/data/msgBg.png) no-repeat;
						background-size:cover;
						margin-top: 6%;
					}
          .right_middle {
						width: 100%;
            height: 26%;
            min-height: 260px;
						background: url(../assets/img/data/msgBg.png) no-repeat;
						background-size:cover;
						margin-top: 6%;
					}


					.highcharts-credits {
						display: none;
					  }
					  .highcharts-legend {
						display: none;
					  }

            .rotate-page-content-box-container{
  width: 50%;
  height: 100px;
  margin-left:10% ;
  position: relative;
  top:-30px;
  left:35%;
}

   .rotate-item {
      width: 30%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      cursor: pointer;
      transition:transform 0.5s;
      letter-spacing:5px;
      border-radius: 12px;
    }
    .item0{
      transform:  rotateX(-16deg)rotateY(0) translateZ(20vw);
    }
    .item1{
      transform: rotateX(-16deg) rotateY(25deg) translateZ(20vw);
      position: relative;
      top:-60px;
    }
    .item2{
      transform:  rotateX(-16deg)rotateY(50deg) translateZ(20vw);
      position: relative;
      top:-120px;
    }
    .item3{
      transform: rotateX(-16deg) rotateY(-50deg) translateZ(20vw);
      position: relative;
      top:-180px;
    }
    .item4{
      transform:  rotateX(-16deg)rotateY(-25deg) translateZ(20vw);
      position: relative;
      top:-240px;
    }
    .itemclass1{
      color:#FFF;
      font-weight: bold;
      font-size: 28px;
      background-color: rgba(233, 233, 161, 0.6);
    }
    .itemclass2{
      color: #091d3f;
      font-size: 20px;
      background-color: rgba(233, 233, 161, 0.3);
    }
    
   
.titleContent {
  margin-left: 2%;
  width: 96%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}
.titleContent .tit {
    width:20%;
    text-align: center;
    font-weight: bold;
  }
  .scroll-list {
    margin-left: 2%;
  width: 96%;
  height: calc(86% - 60px);
  overflow: hidden;
}
.countContent {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  font-size: 14px;
  
}
.countContent .descr {
    width:20%;
    padding: 10px 0;
    text-align: center;
  }
</style>
